import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approvemovement',
  templateUrl: './approvemovement.component.html',
  styleUrls: ['./approvemovement.component.css']
})
export class ApprovemovementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
